import React, { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import { OrderByPrimaryKey } from "../../services/ReduxTookit/Slice/OrderRedux";
import Nodata from "../../component/common-component/Nodata";
import { commonservices } from "../../services/CommonServices";
import { useDispatch } from "react-redux";
import DemoLogo from "../../assets/images/quantummain.svg";
import moment from "moment";

const OrderDetailsModal = ({ showModal, closeModal, payload }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [orderDetailList, setOrderDetailList] = useState(null);

  const [allDetails, setAllDetails] = useState(null);

  const getOrderDetailsList = async () => {
    setLoading(true);
    let body = { id: payload?.orderId };
    dispatch(OrderByPrimaryKey(body))
      .then((response) => {
        if (response?.payload?.isValidate) {
          setAllDetails(response?.payload?.data?.data);
          setOrderDetailList(response?.payload?.data?.data?.dataList2);
        }
        if (!response?.payload?.isValidate) {
          setAllDetails(null);
          setOrderDetailList(null);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const calculateTotalAmount = () => {
    let total = 0;
    orderDetailList?.forEach((item) => {
      total = total + (item?.finalamount ? parseFloat(item?.finalamount) : 0);
    });
    return total?.toFixed(2);
  };

  useEffect(() => {
    getOrderDetailsList();
  }, [payload]);
  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex gap-2 align-items-center">
            <h6>Order No:</h6>
            <h6>{allDetails?.dataList1?.[0]?.orderno}</h6>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="table-wrapper-main">
          <Table responsive>
            <thead>
              <tr>
                <th>Machine Name</th>
                <th>Developer Name</th>
                <th className="text-center">Innovation</th>
                <th className="text-end">Price</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <Loader type={LoaderType.TableRow} count={2} nooftd={4} />
              ) : (
                <>
                  {orderDetailList ? (
                    <>
                      {orderDetailList?.map((item) => {
                        return (
                          <tr key={`orderDetail-${item?.orderid}`}>
                            <td className="text-start">
                              <div className="order-detail">
                                <div
                                  className={`order-detail-machine-img ${commonservices.MachineStatus(
                                    item?.status
                                  )}`}
                                >
                                  <img
                                    src={item?.machinelogo}
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null;
                                      currentTarget.src = DemoLogo;
                                    }}
                                    alt="marketplace"
                                  />
                                </div>
                                <h5>
                                  {item?.machinename ? item?.machinename : ""}
                                </h5>
                              </div>
                            </td>
                            <td>
                              {item?.subscribername ? item?.subscribername : ""}
                            </td>
                            <td className="text-center">
                              {item?.createdon
                                ? `Since ${moment(item?.createdon).format(
                                    "YYYY"
                                  )}`
                                : ""}
                            </td>
                            <td className="text-end">
                              {item?.finalamount > 0
                                ? `$${item?.finalamount?.toFixed(2)}`
                                : "Free"}
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={3} className="text-right bold-black"></td>
                        <td className="text-end">
                          <span>
                            Quantity:{" "}
                            <strong className="bold-black">
                              {orderDetailList?.length}
                            </strong>
                          </span>{" "}
                          |{" "}
                          <span>
                            Total:{" "}
                            <strong className="bold-black">
                              ${calculateTotalAmount()}
                            </strong>
                          </span>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td colSpan={4}>
                        <Nodata />
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OrderDetailsModal;
